import React, { useMemo } from 'react';
import ApiContext from './api.context';
import { ApiService } from '../../../store/services/api-service';
import { useDispatch } from '../store-provider/dispatch.context';
import { useLocalStorage } from '../local-storage-provider/local-storage.context';
import handleError from '../../../store/modules/root/handleError';
import { handleSuccess } from '../../../store/modules/root/handleSuccess';

export interface IApiConfig {
  uri: string;
  headers?: Record<string, string>;
}

interface IApiProviderProps {
  apiConfig: IApiConfig;
  children: React.ReactNode;
}

const ApiProvider = ({
  children, apiConfig,
}: IApiProviderProps): JSX.Element => {
  const { uri } = apiConfig;
  const localStorageService = useLocalStorage();
  const dispatch = useDispatch();

  const api = useMemo(() => new ApiService(
    uri,
    handleError(dispatch),
    handleSuccess,
    localStorageService,
  ), [uri, handleError, localStorageService]);
  return (
    <ApiContext.Provider value={api}>
      {children}
    </ApiContext.Provider>
  );
};

ApiProvider.displayName = 'ApiProvider';

export default ApiProvider;
